const theme = {
    palette: {
      primary: {
        light: "#5e788f",
        main: "#4a5e71",
        dark: "#415162",
        contrastText: "#fff"
      },
      secondary: {
        light: "#63acee",
        main: "#4ca0eb",
        dark: "#1e88e5",
        contrastText: "#fff"
      }
    },
    typography: {
      fontSize: 11
    }
  };
  
  export default theme;
  